import { render, staticRenderFns } from "./distributeEchart.vue?vue&type=template&id=82f46cd0&scoped=true"
import script from "./distributeEchart.vue?vue&type=script&lang=js"
export * from "./distributeEchart.vue?vue&type=script&lang=js"
import style0 from "./distributeEchart.vue?vue&type=style&index=0&id=82f46cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f46cd0",
  null
  
)

export default component.exports